
export class QuoteStatusModel {
    bidPlaced = 'BID_PLACED';
    bidExpired = 'BID_EXPIRED';
    offerReceived = 'OFFER_RECEIVED' ;
    offerExpired = 'OFFER_EXPIRED';
    accepted = 'ACCEPTED';
    rejected = 'REJECTED' ;
    cancelled = 'CANCELLED';
}
